import { useMemo } from 'react';

import { ESubscriptionStatus, TSubscription } from '@mopla/data-models';

type TSectionsVisibility = {
	showLegalSection: boolean;
	showOptionsSection: boolean;
	showHelpSection: boolean;
};

export const useDTicketSectionsVisibility = (
	subscription: TSubscription
): TSectionsVisibility => {
	const sectionsVisibility = useMemo(() => {
		// Hide sections for pending subscriptions
		const isPending = subscription?.status === ESubscriptionStatus.PENDING;

		return {
			showLegalSection: !isPending,
			showOptionsSection: !isPending,
			showHelpSection: !isPending,
		};
	}, [subscription]);

	return sectionsVisibility;
};
